import axios from "@lib/axios";

export async function getUserLists() {
  const res = await axios.get("/users/lists");
  return res.data.data;
}

export async function getUserList(userListUuid) {
  const res = await axios.get(`/users/lists/${userListUuid}`);
  return res.data.data;
}

export async function postUserList(data) {
  const res = await axios.post("/users/lists", data);
  return res.data.data;
}

export async function putUserList(userListUuid, data) {
  const res = await axios.put(`/users/lists/${userListUuid}`, data);
  return res.data.data;
}

export async function deleteUserList(userListUuid) {
  const res = await axios.delete(`/users/lists/${userListUuid}`);
  return res.data.data;
}

export async function postProductToUserList(userListUuid, data) {
  const res = await axios.post(`/users/lists/${userListUuid}/products`, data);
  return res.data.data;
}

export async function deleteProductFromUserList(userListUuid, productId) {
  const res = await axios.delete(`/users/lists/${userListUuid}/products/${productId}`);
  return res.data.data;
}

export async function getUserListSuggestedProducts(userListUuid) {
  const res = await axios.get(`/users/lists/${userListUuid}/suggested_products`);
  return res.data.data;
}
